module.exports = __webpack_public_path__ + "static/media/81680032-FkG0wSgs.b025b4c5.JPG";